import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-1dfbdb14"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "multiselect-list" };
const _hoisted_2 = ["value", "disabled", "name", "id"];
const _hoisted_3 = ["for"];
import { ref, watch } from "vue";
// Define props for the MultiSelectCheckbox component
export default /*#__PURE__*/ _defineComponent({
    __name: 'MultiSelectCheckbox',
    props: {
        options: {
            type: Array,
            required: true,
            default: () => [],
        },
        value: {
            type: Array,
            default: () => [],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            default: "checkbox-group",
        },
    },
    emits: ["update:selectedOption"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        // Internal value to support v-model
        const selectedValues = ref(props.value);
        // Define the `emit` function using `defineEmits`
        // Define emits to trigger the update:value event for v-model binding
        const emit = __emit;
        // Watch for changes in selectedValues and update the parent component via v-model
        watch(selectedValues, (newValues) => {
            emit("update:selectedOption", newValues); // Trigger the event to update parent model
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: option.value
                    }, [
                        _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            value: option.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedValues).value = $event)),
                            disabled: __props.disabled,
                            name: option.value,
                            id: option.value
                        }, null, 8, _hoisted_2), [
                            [_vModelCheckbox, selectedValues.value]
                        ]),
                        _createElementVNode("label", {
                            for: option.value,
                            class: _normalizeClass(['checkbox-label', _ctx.buttonClass])
                        }, _toDisplayString(option.label), 11, _hoisted_3)
                    ]));
                }), 128))
            ]));
        };
    }
});
